import { FORM_VALID, type Validator } from '@ds/components/Form'

export function validTextLength<Values extends object>(
  minTextLength: number,
  message: string,
): Validator<Values> {
  return (value: unknown, _values: Values) => {
    if (typeof value === 'string') {
      return value.trim().length < minTextLength ? message : FORM_VALID
    }

    return message
  }
}
